function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Vue from 'vue';
import QRadio from '../radio/QRadio.js';
import QCheckbox from '../checkbox/QCheckbox.js';
import QToggle from '../toggle/QToggle.js';
import DarkMixin from '../../mixins/dark.js';
import ListenersMixin from '../../mixins/listeners.js';
import cache from '../../utils/cache.js';
var components = {
  radio: QRadio,
  checkbox: QCheckbox,
  toggle: QToggle
};
var typeValues = Object.keys(components);
export default Vue.extend({
  name: 'QOptionGroup',
  mixins: [DarkMixin, ListenersMixin],
  props: {
    value: {
      required: true
    },
    options: {
      type: Array,
      validator: function validator(opts) {
        return opts.every(function (opt) {
          return 'value' in opt && 'label' in opt;
        });
      }
    },
    name: String,
    type: {
      "default": 'radio',
      validator: function validator(v) {
        return typeValues.includes(v);
      }
    },
    color: String,
    keepColor: Boolean,
    dense: Boolean,
    size: String,
    leftLabel: Boolean,
    inline: Boolean,
    disable: Boolean
  },
  computed: {
    component: function component() {
      return components[this.type];
    },
    model: function model() {
      return Array.isArray(this.value) ? this.value.slice() : this.value;
    },
    classes: function classes() {
      return 'q-option-group q-gutter-x-sm' + (this.inline === true ? ' q-option-group--inline' : '');
    },
    attrs: function attrs() {
      if (this.type === 'radio') {
        var attrs = {
          role: 'radiogroup'
        };

        if (this.disable === true) {
          attrs['aria-disabled'] = 'true';
        }

        return attrs;
      }
    }
  },
  methods: {
    __update: function __update(value) {
      this.$emit('input', value);
    }
  },
  created: function created() {
    var isArray = Array.isArray(this.value);

    if (this.type === 'radio') {
      if (isArray) {
        console.error('q-option-group: model should not be array');
      }
    } else if (isArray === false) {
      console.error('q-option-group: model should be array in your case');
    }
  },
  render: function render(h) {
    var _this = this;

    return h('div', {
      "class": this.classes,
      attrs: this.attrs,
      on: _objectSpread({}, this.qListeners)
    }, this.options.map(function (opt, i) {
      var child = _this.$scopedSlots['label-' + i] !== void 0 ? _this.$scopedSlots['label-' + i](opt) : _this.$scopedSlots.label !== void 0 ? _this.$scopedSlots.label(opt) : void 0;
      return h('div', [h(_this.component, {
        props: {
          value: _this.value,
          val: opt.value,
          name: opt.name === void 0 ? _this.name : opt.name,
          disable: _this.disable || opt.disable,
          label: child === void 0 ? opt.label : void 0,
          leftLabel: opt.leftLabel === void 0 ? _this.leftLabel : opt.leftLabel,
          color: opt.color === void 0 ? _this.color : opt.color,
          checkedIcon: opt.checkedIcon,
          uncheckedIcon: opt.uncheckedIcon,
          dark: opt.dark || _this.isDark,
          size: opt.size === void 0 ? _this.size : opt.size,
          dense: _this.dense,
          keepColor: opt.keepColor === void 0 ? _this.keepColor : opt.keepColor
        },
        on: cache(_this, 'inp', {
          input: _this.__update
        })
      }, child)]);
    }));
  }
});